 <form class="f-col blank-form" [formGroup]="designationForm">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managecompany.ccdesignation']}} <div class="dot">.</div> <span class="optional">{{content?.['b2b.managecompany.optional']}}</span></h2>
        <a tabindex="0" role="button" class="link" (keydown.enter)="addNewDesignation()" (click)="addNewDesignation()" *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew"><mat-icon fontSet="material-symbols-outlined" class="edit-icon">add</mat-icon> {{content?.['b2b.managecompany.addnew']}}</a>
    </div>
    <div class="section-content" *ngIf="Addnew">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.managecompany.tpaddesignation']}}</mat-label>
                        <input matInput formControlName="designation" (keypress)="blockInvalidChars($event)" (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)">
                        <mat-error *ngIf="designationForm.get('designation')?.hasError('required')"> {{dictionaryContent?.['b2b.managecompany.designationnamereq']}} </mat-error>
                        <mat-error *ngIf="designationForm.get('designation')?.hasError('duplicate')"> {{dictionaryContent?.['b2b.managecompany.designationnameexists']}} </mat-error>
                        <mat-error *ngIf="designationForm.get('designation')?.hasError('maxlength')"> {{dictionaryContent?.['b2b.managecompany.designationnamemaxlimit']}} </mat-error>
                        <mat-error *ngIf="designationForm.get('designation')?.hasError('pattern')"> {{dictionaryContent?.['b2b.managepolicy.alphabeticchar']}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">Associate with Branch:</label>
                        <div class="f-row mat-check-group">
                            <mat-checkbox class="checkbox-wrapper" *ngFor="let branch of commonObjPipes.GetAssociatedWithBranchId.pipe" 
                            [checked]="associateWithBranchArray.includes(branch.ID.toString())" (change)="onCheckboxChange($event, branch.ID)">{{branch.Name}}</mat-checkbox>
                        </div>
                    </div>
                    <div *ngIf="designationForm.controls['associateWithBranch'].invalid && designationForm.controls['associateWithBranch'].touched" class="error-message">
                        At least one branch must be selected.
                      </div>
                </div>
            </div> -->
            <div class="f-row">
                <mat-form-field class="mat-chip-input custom-designation-mat-dropdown-parent">
                    <mat-label>{{content?.['b2b.managecompany.associateoficelocation']}}</mat-label>
                    <mat-chip-grid #chipGrid aria-label="Fruit selection">
                      <mat-chip-row *ngFor="let name of branchName" (removed)="remove(name)">
                        {{name}}
                        <button matChipRemove [attr.aria-label]="'remove ' + name">
                          <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                      </mat-chip-row>
                    </mat-chip-grid>
                    <input [placeholder]="content?.['b2b.managecompany.tpaddesignation']" #autoInput="matAutocompleteTrigger" [formControl]="associateWithBranch" [matChipInputFor]="chipGrid" [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" (keypress)="_CommonService.blockInvalidCharacters($event)" (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)"maxlength="50"/>
                    <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1
                    </mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                      <mat-option *ngFor="let branch of filteredBranch | async" [value]="branch.corpBranchId">
                        <div (keydown.enter)="optionClicked(branch); $event.stopPropagation()" (keyup.space)="optionClicked(branch); $event.stopPropagation()" (click)="optionClicked(branch); $event.stopPropagation()">
                        <mat-checkbox class="checkbox-wrapper" [checked]="selectedBranchIdsMap[branch.corpBranchId]" (change)="onCheckboxChange($event,branch,'custom-designation-mat-dropdown-parent','custom-autocomplete')" (keyup.enter)="$event.stopPropagation()" (keyup.space)="$event.stopPropagation()" (click)="$event.stopPropagation()"></mat-checkbox>
                        {{branch.corpBranchName}}
                    </div>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
            </div>
            <mat-error *ngIf="associateWithBranch.touched && noRecordFound"> {{dictionaryContent?.['b2b.managecompany.validbranch']}} </mat-error>

        </div>
        <div class="inner-action">
            <button mat-button class="button--secondary-small" (click)="onCancel()">{{content?.['b2b.managecompany.cancel']}}</button>
            <button mat-button class="button--primary-small" (click)="onSave()" [class.disabled]="designationForm.invalid">{{content?.['b2b.managecompany.save']}}</button>
        </div>
    </div>

    <div class="section-table data-listing" *ngIf="commonObjPipes.GetAllDetails.pipe.length>0 && !Addnew">
        <table mat-table [dataSource]="commonObjPipes.GetAllDetails.pipe" class="mat-elevation-z0">
            <ng-container matColumnDef="Designation">
                <th mat-header-cell *matHeaderCellDef>{{content?.['b2b.managecompany.ccdesignation']}}</th>
                <td mat-cell *matCellDef="let element"> {{element.designation}} </td>
            </ng-container>
            <ng-container matColumnDef="Actions">
                <th mat-header-cell *matHeaderCellDef> {{content?.['b2b.managecompany.ddactions']}} </th>
                <td mat-cell *matCellDef="let element" class="onclick-links">
                    <!-- <a class="onclick-cell primary-link" (click)="onEdit(element)">Edit</a>
                    <a class="onclick-cell warm-link" (click)="onRemove(element)">Remove</a> -->
                    <a tabindex="0" role="button" aria-label="Edit item" class="onclick-cell primary-link" (keydown.enter)="onEdit(element)" (click)="onEdit(element)"><mat-icon fontSet="material-symbols-outlined">Edit</mat-icon></a>
                    <a tabindex="0" role="button" aria-label="Remove item" class="onclick-cell warm-link" (keydown.enter)="onRemove(element)" (click)="onRemove(element)"><mat-icon fontSet="material-symbols-outlined">Delete</mat-icon></a>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <ng-container *ngIf="(!isLoading && commonObjPipes.GetAllDetails.pipe.length==0) && !Addnew">
        <app-cam-empty-state (myEvent)="handleEvent($event)" [heading]="content?.['b2b.managecompany.tpnodesignationtitle']" [content]="content?.['b2b.managecompany.tpnodesignationdesc']" [navigateTo]="'/cam/company-management/designation'"> </app-cam-empty-state>
    </ng-container>
</form>
<ng-template #selectionWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title"> {{content?.warningList[0]?.title}} </h2>
                    <!-- <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                    </div> -->
                </div>    
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">{{content?.warningList[0]?.description}}</div>
                </mat-dialog-content>    
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{content?.warningList[0]?.cancelCTAText}}</button>
                        <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{content?.warningList[0]?.confirmCTAText}}</button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>